import { actionTypes } from "./actionTypes.js";

/*---------------------------
| State Updater (reducer)
---------------------------*/
const reducer = (state, action) => {
    switch (action.type) {
        case actionTypes.ASDL_SET_IS_READY_FOR_DOWNLOAD: {
            return {
                ...state,
                isReadyForDownload: action.isReadyForDownload
            };
        }
        case actionTypes.ASDL_SET_ATTRIBUTION_REQUIRED: {
            return {
                ...state,
                attribution: {
                    ...state.attribution,
                    isRequired: action.isRequired
                }
            };
        }
        case actionTypes.ASDL_SET_ATTRIBUTION_IS_VISIBLE: {
            return {
                ...state,
                attribution: {
                    ...state.attribution,
                    isVisible: action.isVisible
                }
            };
        }
        case actionTypes.ASDL_SET_ATTRIBUTION_COPIED: {
            return {
                ...state,
                attribution: {
                    ...state.attribution,
                    isCopied: action.isCopied
                }
            };
        }
        case actionTypes.ASDL_SET_SHOW_PUR_TYPE_DRAWER: {
            return {
                ...state,
                showPurchaseTypeDrawer: action.showPurchaseTypeDrawer
            };
        }
        case actionTypes.ASDL_SET_SHOW_SPEECH_BUBBLE: {
            return {
                ...state,
                showSpeechBubble: action.showSpeechBubble
            };
        }
        case actionTypes.ASDL_SET_PURCHASE_TYPE: {
            return {
                ...state,
                purchaseType: action.purchaseType
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default reducer;
